module.exports = __webpack_public_path__ + "static/img/news-t.bbea049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news-t.png
// module id = hL32
// module chunks = 4